// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"291":"9290ef0f","495":"bd9ce6c2"}[chunkId] + ".chunk.css";
};